import consent from '../../../backend/resources/renewal-consent.json';
import diff from 'recursive-diff';
import {postFetch} from '../api/client';

export {consent as renewalConsent};

export interface FilingSignature {
    name: string;
    signatureValue: string;
    signatureType: 'typed' | 'drawn';
    accepted: true;
    consent: typeof consent;
}

export const officerName = (officer: {firstName?: string | null; lastName?: string | null}) =>
    `${officer.firstName ?? ''} ${officer.lastName ?? ''}`.trim();

export function signatureIsValid(officer: any, signature: string, typed: boolean): boolean {
    return !!officer && officer.remove !== true && signatureMatchesName(officerName(officer), signature, typed);
}

export function signatureMatchesName(name: string, signature: string, typed: boolean): boolean {
    return !!name.trim() && !!signature.trim() && (!typed || signature.trim().toLowerCase() === name.toLowerCase());
}

export async function saveRenewalSignature(original: any, reviewedCompany: any, signerIndex: number, signature: string, typed: boolean): Promise<string> {
    const officer = reviewedCompany.officers[signerIndex];
    if (!signatureIsValid(officer, signature, typed)) throw new Error('Please provide a valid signature for the selected officer.');
    const response = await postFetch({
        endpoint: `signature/${reviewedCompany.id}`,
        authenticate: false,
        body: {
            id: officer.id ?? null,
            name: officerName(officer),
            signerIndex,
            documentNumber: reviewedCompany.id,
            changes: diff.getDiff(original, reviewedCompany),
            reviewedCompany,
            signature,
            signatureType: typed ? 'typed' : 'drawn',
            accepted: true,
            consent,
        },
    });
    const body = await response.json().catch(() => null);
    if (!response.ok || body?.code !== 200 || typeof body?.message !== 'string' || !body.message) {
        throw new Error(typeof body?.message === 'string' ? body.message : 'Your signature could not be saved. Please try again.');
    }
    return body.message;
}
